import { render } from "./Home.vue?vue&type=template&id=6b8088c2&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=6b8088c2&scoped=true&lang=css"

import exportComponent from "D:\\hym\\WEB\\交接项目\\盘古信息客户应用案例\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b8088c2"]])

export default __exports__